<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"cargoCarrier": "Cargo Carrier",
		"description": "Description",
		"owner": "Owner",
		"registrationNumber": "Reg.no.",
		"driver": "Driver"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"cargoCarrier": "Lastebærer",
		"description": "Beskrivelse",
		"owner": "Eier",
		"registrationNumber": "Reg.nr.",
		"driver": "Sjåfør"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('cargoCarrier')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('description')"
						:value="data.description"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('owner')"
						:value="data.vendor ? data.vendor.name : ''"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('registrationNumber')"
						:value="data.registrationNumber"
						labelMarginBottom="5px"
					/>

					<TLabeledValue
						:label="$t('driver')"
						:value="data.driver ? data.driver.name : ''"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'CargoCarrier',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: minmax(150px, 1fr);
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>